import { render } from "./GranularityToggle.vue?vue&type=template&id=3f7704a0&scoped=true"
import script from "./GranularityToggle.vue?vue&type=script&lang=js"
export * from "./GranularityToggle.vue?vue&type=script&lang=js"

import "./GranularityToggle.vue?vue&type=style&index=0&id=3f7704a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7704a0"]])

export default __exports__